var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLikedFullWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "15px",
    viewBox: "0 0 20 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icLikedFullWhite") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Open-topic-Likes-active-filled",
    transform: "translate(-152.000000, -1108.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI/buttons/pill",
    transform: "translate(113.000000, 1100.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(39.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.398125,1.74222222 C10.906875,1.22111111 11.513125,0.785 12.185625,0.480555556 C12.85875,0.174444444 13.59875,0 14.375,0 C15.15125,0 15.89125,0.14 16.564375,0.392777778 C17.2375,0.646111111 17.843125,1.01222222 18.351875,1.46444444 C18.86,1.91666667 19.273125,2.45555556 19.5575,3.05388889 C19.843125,3.65166667 20,4.31 20,5 C20,5.69 19.8425,6.34833333 19.5575,6.94611111 C19.273125,7.54444444 18.86125,8.08333333 18.351875,8.53555556 C17.84375,8.98777778 10.673125,14.7466667 10,15 C9.326875,14.7466667 2.15625,8.98777778 1.6475,8.53555556 C1.13875,8.08333333 0.726875,7.54444444 0.441875,6.94611111 C0.1575,6.34833333 0,5.69 0,5 C0,4.31 0.1575,3.65166667 0.441875,3.05388889 C0.726875,2.45555556 1.138125,1.91666667 1.6475,1.46444444 C2.15625,1.01222222 2.7625,0.646111111 3.435625,0.392777778 C4.108125,0.14 4.848125,0 5.625,0 C6.401875,0 7.141875,0.174444444 7.814375,0.479444444 C8.4875,0.785 9.00498861,1.08741392 9.51436361,1.60852503 C10.0231136,2.1301917 9.88875,2.26388889 10.398125,1.74222222 Z",
    id: "icLikedFullWhite"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLikedFullWhite);
export default __webpack_public_path__ + "static/media/icLikedFullWhite.db72874ce8b1916db9a59826902bcc63.svg";
export { ForwardRef as ReactComponent };